export * from './Avatar';

import Avatar from './Avatar';
export default Avatar;
